<template>
  <div v-if="booking.status.status != 'QUOTE' && steps.length != 0">
    <v-card
      elevation="10"
      class="main"
      style="border-radius: 30px;"
      >
      <v-row  no-gutters :style="$vuetify.breakpoint.smAndDown ? 'margin-top: -25px;' : ''">
        <div align="center" class="info--text" style='width: fit-content; height: fit-content; margin: 0 auto; padding: 2px 4px'>
          Booking <span v-if="booking.orderNumber.number != 1000" class="primary--text" style="font-size: 18px;">#{{ booking.orderNumber.number }}</span>
        </div>
      </v-row>
      <v-container>
        <v-row justify="center" :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">

        <v-col align="start" class="white--text">
          <p style="font-size: 22px; font-weight: bold;"> {{ booking.capturedAddress.split(', South Africa').join(' ') }} </p>
        </v-col>
        <v-col align="center" class="info--text">
          <p style="font-size: 18px;"> {{ booking.preferredTime == 'AM' ? `${convertDate(booking.preferredDate)} AM` : `${convertDate(booking.preferredDate)} PM` }} </p>
        </v-col>
      </v-row>
      </v-container>
        <v-stepper v-model="step" class="elevation-0 " alt-labels flat>
          <v-stepper-header class="elevation-0 main pt-5 steps-container" >
            <template v-for="n in steps.length">
              <v-stepper-step
                  :key="`${n}-step`"
                  :complete="step >= n"
                  :step="n"
                  :class="`px-1 booking-step booking-step-${n}`"
              >
                <div v-if="step == n">
                  <v-img
                    style="position: absolute; top: -30px; left: 60px;"
                    class="truck-icon"
                    src="@/assets/icons/dump-truck.svg"
                    width="50"
                    height="50"/>
                </div>
                <span :class="step >= n ? 'primary--text' : 'info--text'"> {{ steps[n - 1] }} </span>
              </v-stepper-step>
              <v-divider
                  class="primary"
                  v-if="n !== steps.length"
                  :key="n"
              ></v-divider>
            </template>
          </v-stepper-header>
          <v-stepper-header class="elevation-0 main pb-8 mobile-steps" v-if="this.$vuetify.breakpoint.smAndDown">
            <v-row>
                <v-col align="center" v-for="n in steps.length" :key="`${n}-step`">
                  <div v-if="step == n">
                    <v-img
                      style="position: absolute; top: -5px;"
                      :style="step == 1 ? '' : step == 2 ? 'left: 43%' : 'left: 78%'"
                      class="truck-icon"
                      src="@/assets/icons/dump-truck.svg"
                      width="50"
                      height="50"/>
                  </div>
                  <span :class="step >= n ? 'primary--text' : 'info--text'"> {{ steps[n - 1] }} </span>
                </v-col>
              </v-row>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="2">
              <SchedulingBooking v-bind:booking="booking" />
              <ScheduledBooking v-bind:booking="booking" />
            </v-stepper-content>
            <v-stepper-content step="3">
              <DroppedBin v-bind:booking="booking"/>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
    </v-card>
  </div>
</template>

<script>
import SchedulingBooking from '@/components/bookings/client/SchedulingBooking';
import ScheduledBooking from '@/components/bookings/client/ScheduledBooking';
import DroppedBin from '@/components/bookings/client/DroppedBin.vue';
export default {
  name: 'BookingCard',
  components: {
    SchedulingBooking,
    ScheduledBooking,
    DroppedBin,
  },
  props: {
    booking: Object,
  },
  computed: {
    steps(){
      let s = [];
      let status_type = this.booking.status.type.charAt(0).toUpperCase() + this.booking.status.type.slice(1).toLowerCase();
      
      if (this.booking.vehicle.type.toLowerCase().includes('truck')) {
        s = ['Booking confirmed', `${this.booking.status.status == 'SCHEDULING' ? 'Scheduling collection' : `${status_type} confirmed` }`, 'Loaded'];
      } if (status_type == 'Exchange') {
        s = ['Booking confirmed', `${this.booking.status.status == 'SCHEDULING' ? 'Scheduling exchange' : `${status_type} confirmed` }`, 'Exchanged'];
      } if (status_type == 'Collection') {
        s = ['Booking confirmed', `${this.booking.status.status == 'SCHEDULING' ? 'Scheduling collection' : `${status_type} confirmed` }`, 'Collected'];
      } if (status_type == 'Delivery'){
        s = ['Booking confirmed', `${this.booking.status.status == 'SCHEDULING' ? 'Scheduling delivery' : `${status_type} confirmed` }`, 'Bin at location'];
      }
      return s;
    },
    step(){
      let n = 1;
      switch (this.booking.status.status) {
      case 'DROPPED':
        n = 3;
        break;
      case 'SCHEDULING':
        n = 2;
        break;
      case 'SCHEDULED':
        n = 2;
        break;
      default:
        break;
    }
    return n;
    }
  },
  methods: {
    convertDate(date) {
      const stringDate = new Date(date);
      const options = { day: 'numeric', month: 'short', year: 'numeric' };
      return `${stringDate.toLocaleDateString('en-GB', options)}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes idle-shake {
  0%, 100% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-1px);
  }
  50% {
    transform: translateY(1px);
  }
  75% {
    transform: translateY(-1px);
  }
}

.truck-icon {
  animation: idle-shake 0.5s infinite;
}
@media screen and (max-width: 500px) {
  .steps-container {
    display: flex;
    justify-content: space-between;
    gap: 8px;
  }
  .booking-step-1{
    flex-basis: 30% !important;
  }
  .booking-step-2{
    flex-basis: 50% !important;
  }
  .booking-step-3{
    flex-basis: 30% !important;
  }
}

</style>